module.exports = __webpack_public_path__ + "static/media/zoo.fd6347e6.svg";